/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime: 2021-12-02 18:21:36
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\editingCenterRouter.js
 * @Description: 采编中心路由
 */
'use strict';
angular.module('editingCenterRouterModule', ['editingCenterSubjectModule']).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.editctr', {
                url: '/editctr',
                views: {
                    'main@front': {
                        templateUrl: './editingCenter/index_tpl.html',
                        controller: 'EditingCenterController',
                    },
                    'left@front.editctr': {
                        templateUrl: './editingCenter/left_tpl.html',
                        controller: 'editingCenterNavController',
                    },
                },
            })
            .state('fgd', {
                url: '/fgd?authorids&fgdid&newsid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/fgdIframe/fgdIframe_tpl.html',
                        controller: 'EditingFgdIframeCtrl',
                    },
                },
            })
            .state('weixinedit', {
                url: '/weixinedit',
                views: {
                    '': {
                        templateUrl: './editingCenter/weixin/addEdit/main_tpl.html',
                        controller: 'WeiXinEditCtrl',
                    },
                },
            })
            .state('previewtool', {
                url: '/previewtool?id&issite&isAll',
                views: {
                    '': {
                        templateUrl: './components/service/previewToolService/template/previewTool_tpl.html',
                        controller: 'previewToolCtrl',
                    },
                },
            }).state('repeatcompare', {
                url: '/repeatcompare?id&pubdate',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/issuedByForce/repeatCompare/repeatCompare_tpl.html',
                        controller: 'repeatCompareCtrl',
                    },
                },
            });
    },
]);
